module.exports = __webpack_public_path__ + "img/noResult2.7d434a97.png";